module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "silentplace"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-4"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_cat_view.jpg",
      "alt": "focus room coworking bratislava"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-4"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_corner_call_room.jpg",
      "alt": "focus room coworking bratislava"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("🎯🧠 Silent Place to Work in Bratislava")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("📍 Downtown location")]), _vm._v(" "), _c('p', [_vm._v("👩‍🎨 Creative environment")]), _vm._v(" "), _c('p', [_vm._v("📚 Knowledge rich community")]), _vm._v(" "), _c('p', [_vm._v("🧠 Perfect for brainstorming")]), _vm._v(" "), _c('p', [_vm._v("🎧 Accoustic insulated space")]), _vm._v(" "), _c('p', [_vm._v("🙏 Perfect for Team Collaborations")]), _vm._v(" "), _c('p', [_vm._v("🤙 Great for international video conference hangouts")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our cowork you are supporting our community ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork!"
    }
  }, [_vm._v("\n            I want to try Cowork\n          ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1b7741","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SilentPlace.vue
// module id = 252
// module chunks = 15